__webpack_require__.p = "/artemkorenuk_jsx_01/";